import { render } from "./BaseChip.vue?vue&type=template&id=0b8e7980&scoped=true"
import script from "./BaseChip.vue?vue&type=script&lang=js"
export * from "./BaseChip.vue?vue&type=script&lang=js"

import "./BaseChip.vue?vue&type=style&index=0&id=0b8e7980&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8e7980"]])

export default __exports__